import { getColor } from '@/helpers/utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import { Button, Card, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useSearchParams } from 'react-router-dom';

interface PaginationDomainsProps {
  currentPage: number;
  perPage?: number;
  total: number;
}

export default function PaginationDomains({
  currentPage,
  perPage = 10,
  total,
}: PaginationDomainsProps) {
  const buttonsCount = Math.ceil(total / perPage);
  const [, setSearchParams] = useSearchParams();

  return (
    <Card.Footer className={classNames('d-flex justify-content-center')}>
      <div>
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip style={{ position: 'fixed' }}>قبلی</Tooltip>}
        >
          <Button
            disabled={currentPage === 1}
            variant="falcon-default"
            onClick={() => {
              setSearchParams({ p: String(currentPage - 1) });
            }}
            size="sm"
            className="me-2 text-800"
          >
            <FontAwesomeIcon icon="chevron-right" />
          </Button>
        </OverlayTrigger>
      </div>

      <ul className="pagination mb-0">
        {Array.from({ length: buttonsCount }, (_, index) => index + 1).map(
          page => (
            <li
              key={page}
              className={classNames({
                active: currentPage === page,
              })}
            >
              <Button
                size="sm"
                style={
                  currentPage === page
                    ? {
                        color: getColor(
                          'navbar-vertical-default-link-active-color',
                        ),
                        fontWeight: 'bold',
                      }
                    : { color: getColor('gray-800') }
                }
                onClick={() => {
                  setSearchParams({ p: String(page) });
                }}
                variant="falcon-default"
                className="me-2"
              >
                {`${page}`.toPersianDigit()}
              </Button>
            </li>
          ),
        )}
      </ul>
      <div>
        <OverlayTrigger
          trigger="click"
          placement="top"
          overlay={
            <Tooltip style={{ position: 'fixed' }} id="button-tooltip-2">
              بعدی
            </Tooltip>
          }
        >
          <Button
            variant="falcon-default"
            disabled={currentPage === buttonsCount}
            size="sm"
            className="text-800"
            onClick={() => {
              setSearchParams({ p: String(currentPage + 1) });
            }}
          >
            <FontAwesomeIcon icon="chevron-left" />
          </Button>
        </OverlayTrigger>
      </div>
    </Card.Footer>
  );
}
